import {
  getListEngineerApi,
  postEngPaymentCustomApi,
  upsertEngHistoryApi,
  upsertEngineerApi,
  getEngLeavesApi,
  upsertEngLeaveApi,
  deleteEngLeaveApi,
} from 'helpers/backend_helper'
import { takeEvery, put, call } from 'redux-saga/effects'
import {
  GET_LIST_ENGINEER,
  POST_ENGINEER_PAYMENT_CUSTOM,
  UPSERT_ENGINEER,
  UPSERT_ENG_HISTORY,
  GET_ENG_LEAVES,
  UPSERT_ENG_LEAVE,
  DELETE_ENG_LEAVE,
} from './actionTypes'

const actions = require('./actions')

function* onGetListEngineer() {
  try {
    const result = yield call(getListEngineerApi)
    yield put(actions.getListEngineerSuccess(result))
  } catch (error) {
    yield put(actions.getListEngineerFail(error))
  }
}

function* onPostEngineerPaymentCustom({ payload: events }) {
  try {
    yield call(postEngPaymentCustomApi, events)
    yield put(actions.postEngineerPaymentCustomSuccess('پرداخت انجام شد'))
  } catch (error) {
    yield put(actions.postEngineerPaymentCustomFail(error))
  }
}

function* onUpsertEngineer({ payload: data }) {
  try {
    yield call(upsertEngineerApi, data)
    yield put(actions.upsertEngineerSuccess('کارشناس آپدیت شد'))
    const result = yield call(getListEngineerApi)
    yield put(actions.getListEngineerSuccess(result))
  } catch (error) {
    yield put(actions.upsertEngineerFail(error))
  }
}

function* onUpsertEngHistory({ payload: data }) {
  try {
    yield call(upsertEngHistoryApi, data)
    yield put(actions.upsertEngHistorySuccess({ engId: data.engId, engHistory: data }))
  } catch (error) {
    yield put(actions.upsertEngHistoryFail(error))
  }
}

function* onGetEngLeaves() {
  try {
    const result = yield call(getEngLeavesApi)
    yield put(actions.getEngLeavesSuccess(result))
  } catch (error) {
    yield put(actions.getEngLeavesFail(error))
  }
}

function* onUpsertEngLeave({ payload: data }) {
  try {
    yield call(upsertEngLeaveApi, data)
    yield put(actions.upsertEngLeaveSuccess('درخواست ذخیره شد'))
    const result = yield call(getEngLeavesApi, data.EngId)
    yield put(actions.getEngLeavesSuccess(result))
  } catch (error) {
    yield put(actions.upsertEngLeaveFail(error))
  }
}

function* onDeleteEngLeave({ payload: id }) {
  try {
    yield call(deleteEngLeaveApi, id)
    yield put(actions.deleteEngLeaveSuccess('حذف انجام شد'))
    // after delete we don't have engId here; refresh full list or rely on caller to refresh
    const result = yield call(getEngLeavesApi)
    yield put(actions.getEngLeavesSuccess(result))
  } catch (error) {
    yield put(actions.deleteEngLeaveFail(error))
  }
}

function* saga() {
  yield takeEvery(GET_LIST_ENGINEER, onGetListEngineer)
  yield takeEvery(POST_ENGINEER_PAYMENT_CUSTOM, onPostEngineerPaymentCustom)
  yield takeEvery(UPSERT_ENGINEER, onUpsertEngineer)
  yield takeEvery(UPSERT_ENG_HISTORY, onUpsertEngHistory)
  yield takeEvery(GET_ENG_LEAVES, onGetEngLeaves)
  yield takeEvery(UPSERT_ENG_LEAVE, onUpsertEngLeave)
  yield takeEvery(DELETE_ENG_LEAVE, onDeleteEngLeave)
}

export default saga